import { appointmentsNav } from 'src/features/appointments/nav';
import { clientsNav } from 'src/features/clients/nav';
import { financeNav } from 'src/features/finance/nav';
import { homeNav } from 'src/features/home/nav';
import { scheduleNav } from 'src/features/schedule/nav';
import { servicesNav } from 'src/features/services/nav';
import { useSession } from 'src/features/auth/useAuth';
import type { NavItem } from './navTypes';
// Add one import + one spread per new feature:
// import { fooNav } from 'src/features/foo/nav';

// Ordered the way the day runs: the agenda first, then who it is for, then what
// is sold, then when the salon works, and last what it all came to.
const allNavItems: NavItem[] = [
  ...homeNav,
  ...appointmentsNav,
  ...clientsNav,
  ...servicesNav,
  ...scheduleNav,
  ...financeNav,
];

/** The entries this session may use. */
export function useNavItems(): NavItem[] {
  const user = useSession();
  return allNavItems.filter(
    (item) => !item.roles || (user?.role !== undefined && item.roles.includes(user.role))
  );
}

/** Whether a path is inside an entry — `/clientes/12` is in "Clientas". */
export const isInside = (pathname: string, to: string): boolean =>
  to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(`${to}/`);
